/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './removeData.defs.js'
export * as $defs from './removeData.defs.js'
